import BoxUi from '@components/common/BoxUi';
import TitleUi from '@components/common/TitleUi';
import { CSS_HELPERS, THEME_COLORS } from '@theme/constants';
import { Col, Row, Typography } from 'antd';
import styled from 'styled-components';
import { formatMoney } from 'utils/moneyUtils';

const IndicadorGlobal = ({ data }) => {
    const { document } = data;
    const cierreMensual = transposeHandler(document.cierreMensual);
    const cierreSemanal = transposeHandler(document.cierreSemanal);

    return (
        <BoxUi background>
            <TitleUi titulo="Indicadores Financieros" />
            <Row justify="center" gutter={[12,12]}>
                <Col xs={24} sm={12} md={8}>
                    <Card>
                        <CardHeader>
                            <Typography.Title level={5}>
                                Cierre Mensual  - <span className="cappi">{cierreMensual.periodo}</span>
                            </Typography.Title>
                        </CardHeader>
                        <CardBody>


                            {cierreMensual.data.map(item => (
                                <div className="moneyContainer" key={item.key}>
                                    <p className="xs strong600">{item.titulo}</p>
                                    <p className="xs moneyData"> {fixSwitcher(item.key, item.valor)}</p>
                                </div>
                            ))}
                        </CardBody>
                    </Card>
                </Col>
                <Col xs={24} sm={12} md={8}>
                    <Card>
                        <CardHeader>
                            <Typography.Title level={5}>
                                Cierre Semanal  - <span className="cappi">{cierreSemanal.periodo}</span>
                            </Typography.Title>
                        </CardHeader>
                        <CardBody>
                            {cierreSemanal.data.map(item => (
                                <div className="moneyContainer" key={item.key}>
                                    <p className="xs strong600">{item.titulo}</p>
                                    <p className="xs moneyData"> {fixSwitcher(item.key, item.valor)}</p>
                                </div>
                            ))}
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </BoxUi>
    );
}

export default IndicadorGlobal;

const transposeHandler = (data) => {

    


    let dataSource = Object.entries(data).map(item => {
        return {
            key: item[0],
            titulo: tagSwitcher(item[0]),
            valor: item[1],
        }
    });

    


    dataSource = {
        "periodo": dataSource[0].valor,
        data: dataSource.splice(1, dataSource.length)
    }

    


    dataSource = {
        periodo: dataSource.periodo.substring(0, 4) + "/" + dataSource.periodo.substring(4, 6),
        data: dataSource.data.map(item => {
            return {
                ...item,
                valor: item.key === "reserva_internacional" ? item.valor * 1000000 : item.valor
            }
        })

    }

    

    return dataSource;
}


const tagSwitcher = (text) => {
    switch (text) {
        case "periodo": return "Período"
        case "inflacion_anual": return "Inflación anual"
        case "inflacion_mensual": return "Inflación mensual"
        case "reserva_internacional": return "Reserva internacional"
        case "riesgo_pais": return "Riesgo país"
        case "tasa_activa": return "Tasa activa"
        case "tasa_pasiva": return "Tasa pasiva"
        case "tasa_prime": return "Tasa prime"
        case "tasa_Libor_90_dias": return "Tasa Libor 90 días"
    }
}
const fixSwitcher = (key, valor) => {
    switch (key) {
        case "inflacion_anual": return `${formatMoney(valor) }  %`
        case "inflacion_mensual": return `${formatMoney(valor)}  %`
        case "reserva_internacional": return `${formatMoney((valor/1000))} Millones `
        case "riesgo_pais": return `${valor}  puntos`

        case "tasa_activa": return `${valor}  %`
        case "tasa_pasiva": return `${valor}  %`
        case "tasa_prime": return `${valor}  %`
        case "tasa_Libor_90_dias": return `${valor}  %`

      
    }
}


// const Grid = styled.div`
//     width:100%;
//     display: flex;
//     justify-content: center;
//     flex-flow: wrap;
// `;

// const Item = styled.div`
//     background:red;
//     width:27%;
//     @media screen and  (min-width: ${MEDIA_SCREENS.LG}px)  { 
//     }
//     @media screen and  (min-width: ${MEDIA_SCREENS.MD}px) and (max-width: ${MEDIA_SCREENS.LG}px) { 
//     };
//     @media screen and  (min-width: ${MEDIA_SCREENS.SM}px) and (max-width: ${MEDIA_SCREENS.MD}px) { 
//     }
//     @media screen and  (min-width: ${MEDIA_SCREENS.XS}px) and (max-width: ${MEDIA_SCREENS.SM}px) { 
//     }
//     @media screen and  (min-width: ${0}px) and (max-width: ${MEDIA_SCREENS.XS}px) { 
//     }
//     padding:1em;
// `;

const Card = styled.div`
    background-color:white;
    width: 100%;
    display:flex;
    flex-direction: column;
    align-items:center ;
    border-radius:3em;
    overflow: hidden;
    ${CSS_HELPERS.BOX_SHADOW};

    min-height:30px;
    height:100%;
`;


const CardHeader = styled.div`
    display:flex;
    justify-content:center ;
    align-items:center ;
    padding: .6em;
    .ant-typography { 
        margin:0;
        padding:0;
        color:${THEME_COLORS.light.primary.main}
    }
    border-bottom: 2pt solid ${THEME_COLORS.light.secondary.main};
    width: 100%;

`
const CardBody = styled.div`
    width: 100%;
    height:100%;
    background: rgb(25,39,176);
    background: linear-gradient(201deg, rgba(40,143,212,1) 5%, rgba(22,96,155,1) 88%);
    padding:1em 1.5em;
    p { padding: 0.3em };

    .moneyContainer{
        width:100%; 
        display:flex;
        gap:1em;
        justify-content:space-between;
        align-items:center; 
    };

    .moneyData{
        text-align: right;
        text-justify: right;
        overflow:hidden ;
    }


    .ant-typography, p {
        color:${THEME_COLORS.light.primary.contrastText};
    }
`
const IconCircle = styled.div`
    margin:1em;
    padding:1em;
    border: 2pt solid ${THEME_COLORS.light.secondary.main};
    background:${THEME_COLORS.light.bg.main};
    width:6em;
    height:6em;
    display:flex;
    justify-content:center;
    align-items:center;
    border-radius:50% ;
    background: linear-gradient(201deg, rgba(40,143,212,1) 5%, rgba(22,96,155,1) 88%);
    svg{
        fill:${THEME_COLORS.light.primary.contrastText};
    }
`
